export const mapAssigneesSuggestionsToOptions = assignees => assignees.map(
  ({ id, name }) => ({ value: parseInt(id), label: name })
);
